import { useState, useRef } from 'react';
import { Palette } from 'lucide-react';
import { useTheme } from '@kss/theme';
import { themeConfigs } from '@kss/theme';
import { useClickOutside } from '../../hooks/useClickOutside';
import { cn } from '../../utils/cn';

export default function ThemeSwitcher() {
  const { colorTheme, setColorTheme } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useClickOutside(ref, () => setOpen(false));

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="flex h-8 w-8 items-center justify-center rounded-lg text-content-muted hover:bg-surface-card-hover hover:text-content-primary transition-colors"
        title="Theme"
      >
        <Palette size={18} />
      </button>
      {open && (
        // `flex-wrap` + `max-w-[calc(100vw-1rem)]` keep the swatch row
        // inside narrow phone viewports — previously the row would
        // overflow horizontally when many themes were registered.
        <div className="absolute right-0 top-full mt-2 z-50 flex max-w-[calc(100vw-1rem)] flex-wrap gap-2 rounded-lg border border-border bg-surface-card p-3 shadow-lg">
          {themeConfigs.map((theme) => (
            <button
              key={theme.name}
              onClick={() => {
                setColorTheme(theme.name);
                setOpen(false);
              }}
              title={theme.label}
              className={cn(
                'h-6 w-6 rounded-full border-2 transition-transform hover:scale-110',
                colorTheme === theme.name ? 'border-content-primary scale-110' : 'border-transparent'
              )}
              style={{ backgroundColor: theme.previewColor }}
            />
          ))}
        </div>
      )}
    </div>
  );
}
